import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './CreateJob.css';
import { useAuth } from '../contexts/AuthContext'; // Assuming useAuth is needed for handling user authentication

const CreateJob = () => {
  const [formData, setFormData] = useState({
    title: '',
    experience: '',
    location: '',
    type: 'Full Time',
    shortDescription: '',
    description: '',
    workLocation: 'Remote',
    experienceLevel: 'Internship'
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth(); // Assuming currentUser and logout are part of useAuth

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleDescriptionChange = (value) => {
    setFormData({
      ...formData,
      description: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post('http://localhost:5001/api/jobs', {
        ...formData,
        status: 'open',
        publishDate: new Date(),
        modifiedDate: new Date()
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 201) {
        setFormSubmitted(true);
        console.log('Job created successfully:', response.data);
      }
    } catch (error) {
      setError('Error creating job');
      console.error('Error creating job:', error);
    }
  };

  const handleGoBack = () => {
    navigate('/admindash');
  };

  return (
    <div className="create-job-section">
      <Container className="courses-section my-5">
        <Row className="justify-content-md-center">
          <Col md={6} className="mb-4">
            {currentUser && (
              <div className="auth-links">
                <Button onClick={logout}>Logout</Button>
                <Button variant="link" onClick={handleGoBack}>Dashboard</Button>
              </div>
            )}
            <Card className={`contact-us-card ${formSubmitted ? 'flipped' : ''}`}>
              {formSubmitted ? (
                <Card.Body className="thank-you-message">
                  <Card.Title>Job Created!</Card.Title>
                  <Card.Text>Your job has been created successfully.</Card.Text>
                  <Button variant="primary" onClick={handleGoBack}>
                    Go Back to Admin Dashboard
                  </Button>
                </Card.Body>
              ) : (
                <>
                  <Card.Body className="create-job-content">
                    <Card.Title>Create a Job</Card.Title>
                    <Form onSubmit={handleSubmit}>
                      <Form.Group controlId="formTitle" className="form-row">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                          type="text"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group controlId="formExperience" className="form-row">
                        <Form.Label>Experience</Form.Label>
                        <Form.Control
                          type="text"
                          name="experience"
                          value={formData.experience}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group controlId="formLocation" className="form-row">
                        <Form.Label>Location</Form.Label>
                        <Form.Control
                          type="text"
                          name="location"
                          value={formData.location}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group controlId="formType" className="form-row">
                        <Form.Label>Job Type</Form.Label>
                        <Form.Control
                          as="select"
                          name="type"
                          value={formData.type}
                          onChange={handleChange}
                          required
                        >
                          <option value="Full Time">Full Time</option>
                          <option value="Part Time">Part Time</option>
                          <option value="Contract">Contract</option>
                          <option value="Freelance">Freelance</option>
                        </Form.Control>
                      </Form.Group>

                      <Form.Group controlId="formWorkLocation" className="form-row">
                        <Form.Label>Work Location</Form.Label>
                        <Form.Control
                          as="select"
                          name="workLocation"
                          value={formData.workLocation}
                          onChange={handleChange}
                          required
                        >
                          <option value="Remote">Remote</option>
                          <option value="Hybrid">Hybrid</option>
                          <option value="On-site">On-site</option>
                        </Form.Control>
                      </Form.Group>

                      <Form.Group controlId="formExperienceLevel" className="form-row">
                        <Form.Label>Job Level</Form.Label>
                        <Form.Control
                          as="select"
                          name="experienceLevel"
                          value={formData.experienceLevel}
                          onChange={handleChange}
                          required
                        >
                          <option value="Internship">Internship</option>
                          <option value="Entry level">Entry level</option>
                          <option value="Associate">Associate</option>
                          <option value="Mid-Senior level">Mid-Senior level</option>
                          <option value="Director">Director</option>
                          <option value="Executive">Executive</option>
                        </Form.Control>
                      </Form.Group>

                      <Form.Group controlId="formShortDescription" className="form-row">
                        <Form.Label>Short Description</Form.Label>
                        <Form.Control
                          type="text"
                          name="shortDescription"
                          value={formData.shortDescription}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group controlId="formDescription" className="form-row">
                        <Form.Label>Description</Form.Label>
                        <ReactQuill
                          value={formData.description}
                          onChange={handleDescriptionChange}
                          modules={{
                            toolbar: [
                              [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                              [{ 'align': [] }],
                              [{ 'color': [] }, { 'background': [] }],
                              ['link', 'image', 'video'],
                              ['clean']
                            ],
                          }}
                        />
                      </Form.Group>

                      {error && <p className="text-danger">{error}</p>}

                      <Button variant="primary" type="submit">
                        Create Job
                      </Button>
                    </Form>
                  </Card.Body>
                </>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CreateJob;
